var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTelecharger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt-telecharger-blanc",
    transform: "translate(-4647 -834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bt-t\\xE9l\\xE9charger-blanc",
    transform: "translate(1090.467 -10833.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_220",
    "data-name": "Groupe 220",
    transform: "translate(3335.85 11388.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M232.547,281.875c2.365,0,4.73.011,7.1-.009.5,0,.652.162.65.655q-.022,6.94,0,13.88c0,.462-.131.662-.616.641-.655-.029-1.312-.026-1.967,0-.46.018-.635-.173-.581-.614a.821.821,0,0,0,0-.207c-.066-.493.141-.665.64-.66,1.259.011,1.114.185,1.11-1.136-.008-2.309-.072-4.617-.039-6.925.017-1.242.02-2.485.045-3.726.008-.384-.124-.5-.509-.5q-5.878.018-11.756,0c-.416,0-.53.156-.529.549q.015,5.593,0,11.186c0,.426.134.612.565.566a4.153,4.153,0,0,1,.466,0c.722,0,.731.014.733.716,0,.739-.006.747-.751.749-.587,0-1.175-.023-1.761.007-.495.026-.655-.157-.653-.655.016-4.005.009-8.01.009-12.015,0-.621.028-1.245-.009-1.864-.03-.513.179-.644.662-.64C227.748,281.886,230.147,281.875,232.547,281.875Z",
    transform: "translate(0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M271.847,408.492c.426-.447.858-.889,1.276-1.344.211-.23.373-.215.6-.005.738.679.745.671.049,1.368-.829.829-1.667,1.648-2.481,2.49-.269.278-.449.269-.715,0q-1.368-1.409-2.776-2.78c-.268-.261-.292-.438-.013-.716.659-.655.649-.672,1.3-.016.325.329.634.675.939,1,.251-.155.176-.327.178-.465.008-.9.013-1.792,0-2.688,0-.354.146-.482.493-.5.929-.038.974-.008.975.908q0,1.335,0,2.67Z",
    transform: "translate(-38.453 -110.198)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M258.587,381.571c-1.381,0-2.762-.019-4.142.01-.526.011-.6-.245-.585-.669.017-.4-.069-.809.564-.806q4.22.022,8.44,0c.6,0,.528.4.538.776.011.4-.031.7-.569.7C261.418,381.555,260,381.571,258.587,381.571Z",
    transform: "translate(-26.145 -88.042)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M258.538,350.753c-1.4,0-2.792.006-4.188,0-.554,0-.582-.1-.563-.933.01-.465.246-.513.634-.508,1.286.016,2.573-.008,3.859-.006,1.339,0,2.677.018,4.016.028.069,0,.137.015.206.016.776,0,1.034.375.815,1.141-.088.307-.322.267-.539.268-1.413,0-2.827,0-4.24,0Z",
    transform: "translate(-26.078 -60.437)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112",
    "data-name": "Trac\\xE9 112",
    d: "M258.578,320.2c-1.38,0-2.761-.024-4.14.011-.584.015-.583-.3-.589-.719-.006-.433.037-.71.6-.705q4.166.036,8.333,0c.547,0,.628.245.615.692-.019.673-.037.718-.628.72C261.373,320.2,259.975,320.2,258.578,320.2Z",
    transform: "translate(-26.137 -33.084)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 24,
    height: 24,
    transform: "translate(4647 834)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelecharger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telecharger.c1146b37.svg";
export { ForwardRef as ReactComponent };